<template>
  <router-view />
</template>

<script>
export default {};
</script>
<style>
.el-table__cell {
  position: static !important;
}
</style>


